import { render, staticRenderFns } from "./RangeSliderItem.vue?vue&type=template&id=353481ed&scoped=true&"
import script from "./RangeSliderItem.vue?vue&type=script&lang=js&"
export * from "./RangeSliderItem.vue?vue&type=script&lang=js&"
import style0 from "./RangeSliderItem.vue?vue&type=style&index=0&id=353481ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353481ed",
  null
  
)

export default component.exports